import { lazy, Suspense } from "react";
import { PageSkeleton } from "../../customs/skeleton/main";
const Main = lazy(() => import("../../components/settings/permission/main"));

const Permission = () => {
  return (
    <Suspense fallback={<PageSkeleton />}>
      <Main />
    </Suspense>
  );
};

export default Permission;
